import { Component } from '@angular/core';

@Component({
  selector: 'app-truequote-website',
  templateUrl: './truequote-website.component.html',
})
export class TruequoteWebsiteComponent {}
